import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportListComponent } from './report-list/report-list.component';
import { LoginComponent } from './login/login.component';
import { CheckoutListComponent } from './checkout-list/checkout-list.component';
import { AuthenticationGuard } from './guards/authentication.guard';
import { OnlineGuard } from '@ngx-pwa/offline';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { canActivate: [AuthenticationGuard], path: 'report-list', component: ReportListComponent },
  { canActivate: [AuthenticationGuard], path: 'checkout-list', component: CheckoutListComponent },
  { canActivate: [AuthenticationGuard], path: 'intake-reports', loadChildren: './intake-reports/intake-reports.module#IntakeReportsModule' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
